"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Measurer = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectSpread3 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactMeasure = _interopRequireDefault(require("react-measure"));
var _measurerModule = _interopRequireDefault(require("./measurer.module.scss"));
var MeasurerItem = function MeasurerItem(_ref) {
  var index = _ref.index,
    onResize = _ref.onResize,
    className = _ref.className,
    children = _ref.children;
  var handleResize = (0, _react.useCallback)(function (_ref2) {
    var bounds = _ref2.bounds;
    onResize(index, bounds.width);
  }, [onResize, index]);
  return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
    bounds: true,
    onResize: handleResize
  }, function (_ref3) {
    var measureRef = _ref3.measureRef;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      ref: measureRef
    }, children);
  });
};
var Measurer = function Measurer(_ref4) {
  var items = _ref4.items,
    widths = _ref4.widths,
    onResize = _ref4.onResize,
    className = _ref4.className,
    itemsClassName = _ref4.itemsClassName;
  var handleItemResize = (0, _react.useCallback)(function (index, width) {
    onResize((0, _objectSpread3.default)((0, _objectSpread3.default)({}, widths), {}, (0, _defineProperty2.default)({}, index, width)));
  }, [widths, onResize]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _measurerModule.default['measurer']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(MeasurerItem, {
      key: i,
      className: itemsClassName,
      index: i,
      onResize: handleItemResize
    }, item);
  })));
};
exports.Measurer = Measurer;